import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeTimeZone',
  pure: true,
})
export class RemoveTimeZonePipe implements PipeTransform {
  transform(value: any): string {
    if (!Date.parse(value)) {
      return '';
    }

    return value.replace('Z', '');
  }
}
